/*
 * <quick-add-size> — inline size quick-buy on product cards.
 * Desktop reveals sizes on hover (CSS); mobile toggles them with the trigger.
 * Clicking a size adds the variant to the cart and opens the cart drawer,
 * reusing the theme's cart element (same flow as product-form.js).
 */
if (!customElements.get('quick-add-size')) {
  customElements.define(
    'quick-add-size',
    class QuickAddSize extends HTMLElement {
      constructor() {
        super();
        this.trigger = this.querySelector('.quick-add-size__trigger');
        this.panel = this.querySelector('.quick-add-size__panel');
        this.spinner = this.querySelector('.loading__spinner');
        this.errorWrapper = this.querySelector('.product-form__error-message-wrapper');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.loading = false;

        if (this.trigger) this.trigger.addEventListener('click', this.onTrigger.bind(this));
        this.addEventListener('click', this.onOptionClick.bind(this));
      }

      onTrigger(event) {
        event.preventDefault();
        const isOpen = this.classList.toggle('is-open');
        this.trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }

      onOptionClick(event) {
        const button = event.target.closest('.quick-add-size__option');
        if (!button || button.hasAttribute('disabled') || this.loading) return;
        event.preventDefault();
        this.addToCart(button.dataset.variantId, button);
      }

      setLoading(state, button) {
        this.loading = state;
        if (this.spinner) this.spinner.classList.toggle('hidden', !state);
        if (button) button.classList.toggle('loading', state);
      }

      showError(message) {
        if (!this.errorWrapper) return;
        this.errorWrapper.toggleAttribute('hidden', !message);
        const el = this.errorWrapper.querySelector('.product-form__error-message');
        if (el && message) el.textContent = message;
      }

      addToCart(variantId, button) {
        if (!variantId) return;
        this.showError(false);
        this.setLoading(true, button);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          if (typeof this.cart.setActiveElement === 'function') {
            this.cart.setActiveElement(document.activeElement);
          }
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showError(response.description || response.message);
              if (typeof publish === 'function') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'quick-add-size',
                  productVariantId: variantId,
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (typeof publish === 'function') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'quick-add-size',
                productVariantId: variantId,
                cartData: response,
              });
            }

            if (this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            this.cart.renderContents(response);
            this.classList.remove('is-open');
          })
          .catch((e) => {
            console.error(e);
            this.showError();
          })
          .finally(() => {
            this.setLoading(false, button);
          });
      }
    }
  );
}
